import React from 'react';
import ChemistryOfUnsolvableProblems from '../components/ChemistryOfUnsolvableProblems';

function ChemistryOfUnsolvableProblemsPage() {
  return <ChemistryOfUnsolvableProblems />;
}

export default ChemistryOfUnsolvableProblemsPage;
